import Head from 'next/head'
import * as React from 'react'
import Header from './header'
import Container from './container'
import '../../global.scss'
import { AppProp } from './wrap'

type LayoutProps = {
  children: JSX.Element
  appOpt: AppProp
}
const Layout: React.FC<LayoutProps> = ({ children, appOpt }) => {
  return (
    <>
      <Head>
        <link rel="dns-prefetch" href="//kaas.moqun.cn" />
        <link rel="shortcut icon" href="/img/favicon.ico" />
        <link rel="preload" as="font" />
        <meta
          name="viewport"
          content="width=device-width,user-scalable=no,target-densitydpi=high-dpi,initial-scale=1.0,maximum-scale=1.0"
        />
        <meta
          name="Description"
          content="DioScan allows you to explore and search the Dioxide blockchain for transactions, addresses, tokens, prices and other activities taking place on Dioxide (DIO)"
        />
        <title>{appOpt.title}</title>
        <link rel="canonical" href="https://scan.dioxide.network" />
      </Head>
      <Header app={appOpt} />
      <Container app={appOpt}>{children}</Container>
    </>
  )
}

export default Layout
